export const WEB_BASE_URL = process.env.REACT_APP_WEB_BASE_URL || "http://localhost:3000";

export const COMMON = {
  appLogoUrl: `${WEB_BASE_URL}/logo.png`,
  
};
